<po-page-list #poPageListComponent
  p-title="Notas Guarita {{this.guaritaNome}}"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>


<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-6"
      p-label="Guarita"
      name="CC5GUARITA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC5GUARITA"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="guaritaColumnsFilters"
      [p-field-format]="guaritaFieldFormaterFilters"
      [p-filter-service]="zprLookupService"
      [p-advanced-filters]="guaritaAdvancedFilters"
      [p-literals]="{ modalTitle: 'Guarita' }"
      [p-required]="true"
    ></po-lookup>
    <po-datepicker
      class="po-md-6"
      name="DF2EMISSAO_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DF2EMISSAO_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Emissão de"
    ></po-datepicker>
    <po-datepicker
      class="po-md-3"
      name="DF2EMISSAO_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DF2EMISSAO_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Emissão até"
    ></po-datepicker>
    <po-input
      class="po-md-6"
      name="CC5NUM"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC5NUM"
      p-label="Código Pedido"
      [p-maxlength]="6"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CF2DOC"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CF2DOC"
      p-label="Documento"
      [p-maxlength]="9"
    ></po-input>
  </form>
</po-modal>

<po-modal #modalStatusCancelamento p-title="Status Cancelamento" [p-primary-action]="atualizaStatusCancelamento">

  <po-widget>
    1. Exclusão da Nota &nbsp;
    <po-tag
      p-value="{{statusCancelamento.CF2DOC === ''?'Excluída':'Erro'}}"
      p-color="{{statusCancelamento.CF2DOC === ''?'color-10':'color-07'}}"
    ></po-tag>
  </po-widget>

  <po-widget>
    2. Transmissão Cancelamento &nbsp;
    <po-tag
      p-value="{{statusCancelamento.CF3CODRET !== ''?'Enviada':'Pendente'}}"
      p-color="{{statusCancelamento.CF3CODRET !== ''?'color-10':'color-07'}}"
    ></po-tag>
  </po-widget>

  <po-widget>
    3. Confirmação Cancelamento &nbsp;
    <po-tag
      p-value="{{(statusCancelamento.CF3CODRET === 'M' && statusCancelamento.CF3CODRSEF === '101')?'Confirmada':(statusCancelamento.CF3CODRET == 'M' && statusCancelamento.CF3CODRSEF != '100')?'Não autorizada - Retorno do Sefaz Código {{statusCancelamento.CF3CODRSEF}}':'Pendente'}}"
      p-color="{{(statusCancelamento.CF3CODRET === 'M' && statusCancelamento.CF3CODRSEF === '101')?'color-10':(statusCancelamento.CF3CODRET == 'M' && statusCancelamento.CF3CODRSEF != '100')?'color-08':'color-07'}}"
    ></po-tag>
  </po-widget>
</po-modal>
